import { Component } from '@angular/core';

@Component({
  selector: 'app-zone-actions-drawer',
  templateUrl: './zones-drawer.component.html',
  styleUrls: ['./zones-drawer.component.scss'],
})
export class ZonesDrawerComponent {}
